<template>
  <div class="editor-view">
    <Editor msg="Editor"/>
    <EditorUI/>
  </div>
</template>

<script>
// @ is an alias to /src
import Editor from '@/components/Editor.vue'
import EditorUI from '@/components/EditorUI.vue'

export default {

  name: 'editor',

  components: {
    Editor,
    EditorUI
  }

}
</script>

<style scoped>

.editor-view {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: auto 200px;
}

</style>
